import { Landing } from 'components/templates';
import LanguageContext from 'contexts/language';
import {
  header as headerData,
  projects as projectsData,
  blogs as blogsData,
  skills as skillsData,
  contact as contactData
} from 'data';
import {
  sections as sectionsEn,
  header as headerEn,
  about as aboutEn,
  skills as skillsEn,
} from 'localization/en';
import {
  sections as sectionsId,
  header as headerId,
  about as aboutId,
  skills as skillsId,
} from 'localization/id';
import {
  sections as sectionsFr,
  header as headerFr,
  about as aboutFr,
  skills as skillsFr,
} from 'localization/fr';
import {
  sections as sectionsDe,
  header as headerDe,
  about as aboutDe,
  skills as skillsDe,
} from 'localization/de';
import {
  sections as sectionsJa,
  header as headerJa,
  about as aboutJa,
  skills as skillsJa,
} from 'localization/ja';
import {
  sections as sectionsZh,
  header as headerZh,
  about as aboutZh,
  skills as skillsZh,
} from 'localization/zh';
import React, { useContext } from 'react';

export default function Home() {
  const languange = useContext(LanguageContext);

  let locale;

  if (languange.value === 'en') {
    locale = {
      sections: sectionsEn,
      header: headerEn,
      about: aboutEn,
      skills: skillsEn,
    };
  } else if (languange.value === 'fr') {
    locale = {
      sections: sectionsFr,
      header: headerFr,
      about: aboutFr,
      skills: skillsFr,
    };
  } else if (languange.value === 'de') {
    locale = {
      sections: sectionsDe,
      header: headerDe,
      about: aboutDe,
      skills: skillsDe,
    };
  } else if (languange.value === 'ja') {
    locale = {
      sections: sectionsJa,
      header: headerJa,
      about: aboutJa,
      skills: skillsJa,
    };
  } else if (languange.value === 'zh') {
    locale = {
      sections: sectionsZh,
      header: headerZh,
      about: aboutZh,
      skills: skillsZh,
    };
  } else {
    locale = {
      sections: sectionsId,
      header: headerId,
      about: aboutId,
      skills: skillsId,
    };
  }

  return (
    <Landing
      sections={locale.sections}
      data={{
        header: {
          data: headerData,
          text: locale.header,
        },
        about: {
          text: locale.about.text,
          downloadResume: locale.sections.downloadResume,
        },
        projects: {
          items: projectsData,
          seeMoreGithub: locale.sections.seeMoreGithub,
          projectDetails: locale.sections.projectDetails,
        },
        blogs: {
          items: blogsData,
          moreArticle: locale.sections.moreArticle,
        },
        skills: {
          text: locale.skills.text,
          items: skillsData,
        },
        contact: contactData
      }}
      locale={{ value: languange.value, change: languange.change }}
    />
  );
}
